export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export enum UserRole {
  Investigator = 'CLIENT_INVESTIGATOR',
  ClientTrial = 'CLIENT_TRIAL',
  Admin = 'CLIENT_ADMIN',
  // Client-level role above CLIENT_ADMIN: can assign/revoke CLIENT_ADMIN and
  // delete admin users from the portal's user management page. Only KYP staff
  // (via this admin portal) can grant it.
  SuperAdmin = 'CLIENT_SUPERADMIN',
  ClientDemo = 'KYP_DEMO',
  KYP = 'KYP',
}

export interface ParsedAuthUser {
  cid: string; // clientId
  rls: UserRole[];
  exp: number;
}

export interface AuthUser extends ParsedAuthUser {
  _id: string; // userId
  firstName: string;
  lastName: string;
  photoURL?: string;
  email?: string;
}

export type IAuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: Maybe<AuthUser>;
};

export type LoginResult = {
  // The account has 2FA: ask for a code (or recovery code) and log in again.
  twoFactorRequired?: boolean;
  // The user's client requires 2FA and the account hasn't enrolled yet.
  twoFactorSetupRequired?: boolean;
  // The password is past the client's expiry policy.
  passwordExpired?: boolean;
  // KYP staff refused access (client suspended / account blocked): the message to show.
  accessRefused?: string;
};

export type JWTContextType = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: Maybe<AuthUser>;
  method: 'jwt';
  login: (
    email: string,
    password: string,
    otpCode?: string,
    useRecoveryCode?: boolean
  ) => Promise<LoginResult>;
  logout: () => Promise<void>;
};
